import React from 'react'
import { useNavigate } from 'react-router-dom'
import { Breadcrumb } from 'antd'
import Icon from 'meinian-package/src/component/icon'
import Select from '../../../inspiration/component/inspirationSelect'
import css from './index.module.less'

export type Option={
  label:string,
  value:number,
  childs:Option[],
  parent?:Option
}
export default ({ options }:{options:Option[]}) => {
  const navigate = useNavigate()
  const renderItems = (_options:Option[]) => {
    return _options?.map(m => <Breadcrumb.Item key={m.value}>
      <span onDoubleClick={() => navigate(`/home/sample/${m.value}`)}>
        <Select
          key={m.value}
          option={m?.parent?.childs}
          value={m?.value}
          onChange={(val) => navigate(`/home/sample/${val}`)}
        />
      </span>
    </Breadcrumb.Item>)
  }
  return <div className={css.breadcrumb}>
    <Breadcrumb>
      {
      window.history.length > 1 && <div className={css.back} onClick={() => { navigate(-1) }}>
        <Icon type="m-Vxing_zuo" className={css.icon} />
      </div>
    }
      <Breadcrumb.Item onClick={() => { navigate('/home/workbench/index') }}>
        <span style={{ cursor: 'pointer' }}>工作台</span>
      </Breadcrumb.Item>
      <Breadcrumb.Item onClick={() => navigate('/home/sample')}>
        <span style={{ cursor: 'pointer' }}>样衣管理</span>
      </Breadcrumb.Item>
      {options?.length < 3 ? renderItems(options) : (
        <>
          <Breadcrumb.Item onClick={() => navigate('/home/sample')}>
            ...
          </Breadcrumb.Item>
          {renderItems(options.slice(-2))}
        </>
      )}
    </Breadcrumb>
  </div>
}
